<div *ngIf="!showDropdown">
  <app-verify-credential-item [credentialItem]="membershipCredentialItem" [expanded]="true"></app-verify-credential-item>
</div>
<div
  *ngIf="showDropdown"
  class="membership-item-container"
  [ngStyle]="{ 'margin-bottom': !expanded && credentialListItems.length > 1 ? '-24px' : 'initial' }">
  <div pl-grid="1/1@phone nowrap" style="cursor: pointer;" (click)="toggleExpanded()">
    <se-icon
      pl-grid-el
      pl-grid="shrink@phone"
      name="chevron-right"
      size="500"
      class="membership-item-icon"
      [ngClass]="{ expanded: expanded }">
    </se-icon>
    <span
      pl-grid-el
      pl-grid="shrink@phone"
      class="se-app__content-subtitle--med membership-item-name">
      {{ membershipItem.membership.membership_definition.name }}
    </span>
    <se-tag
      pl-grid-el
      pl-grid="shrink@phone"
      se-data-color="{{ eligibilityStatusTag.color }}"
      se-data-value="{{ eligibilityStatusTag.value }}">
    </se-tag>
  </div>
  <div class="se-text" style="margin-left: 28px;">{{ subtitle }}</div>
  <div class="membership-item-content" [ngClass]="{ expanded: expanded }">
    <ng-container *ngFor="let credentialListItem of credentialListItems">
      <app-verify-credential-list-item
        [credentialListItem]="credentialListItem"
        [expanded]="expanded"
        [bundled]="credentialListItems.length > 1">
      </app-verify-credential-list-item>
    </ng-container>
  </div>
</div>
